import useSWR from 'swr';

import { WorkspaceService } from 'services/WorkspaceService';

// Resolves a workspace document to its public config, which carries the branding (name, logo).
const useWorkspace = (workspaceId: string | null | undefined) => {
    const { data } = useSWR(workspaceId ? `/api/workspaces/${workspaceId}/config` : null, async () => {
        const workspace = await WorkspaceService.get(workspaceId!);

        return workspace && WorkspaceService.getConfig(workspace.key);
    });

    return data;
};

export { useWorkspace };
